import React from "react";

const Marketings = React.lazy(() => import('pages/Marketing/pages/MarketingPage'));
const MarketingsAdd = React.lazy(() => import('pages/Marketing/pages/MarketingAdd'));
const MarketingsEdit = React.lazy(() => import('pages/Marketing/pages/MarketingEdit'));
const MarketingsDetail = React.lazy(() => import('pages/Marketing/pages/MarketingDetail'));

const marketings = [
  {
    path: '/marketings',
    exact: true,
    name: 'Danh sách Marketing',
    function: 'SL_MARKETING_VIEW',
    component: Marketings,
  },
  {
    path: '/marketings/add',
    exact: true,
    name: 'Thêm mới Marketing',
    function: 'SL_MARKETING_ADD',
    component: MarketingsAdd,
  },
  {
    path: '/marketings/edit/:id',
    exact: true,
    name: 'Chỉnh sửa Marketing',
    function: 'SL_MARKETING_EDIT',
    component: MarketingsEdit,
  },
  {
    path: '/marketings/detail/:id',
    exact: true,
    name: 'Chi tiết Marketing',
    function: 'SL_MARKETING_DETAIL',
    component: MarketingsDetail,
  },
]

export default marketings;